import { ButtonOutlined } from 'components/Button'
import { NavDropdown } from 'components/NavBar/NavDropdown'
import { useOnClickOutside } from 'hooks/useOnClickOutside'
import { Box } from 'nft/components/Box'
import { Column } from 'nft/components/Flex'
import { EllipsisIcon } from 'nft/components/icons'
import { bodySmall } from 'nft/css/common.css'
import React from 'react'
import { ReactNode, useReducer, useRef } from 'react'
import styled, { useTheme } from 'styled-components/macro'

import * as styles from './../../../components/NavBar/MenuDropdown.css'
import useCompetitionInfo from '../../../graphql/competition/CompetitionInfo'
import { useActiveLocale } from '../../../hooks/useActiveLocale'

const AdditionalInfoDropdownIcon = styled(Box)`
  display: flex;
  padding-left: 16px;
  img {
    margin-top: auto;
    margin-bottom: auto;
  }
`

const SecondaryLinkedText = ({
  href,
  onClick,
  children,
}: {
  href?: string
  onClick?: () => void
  children: ReactNode
}) => {
  return (
    <Box
      as={href ? 'a' : 'div'}
      href={href ?? undefined}
      target={href ? '_blank' : undefined}
      rel={href ? 'noopener noreferrer' : undefined}
      className={`${styles.SecondaryText} ${bodySmall}`}
      onClick={onClick}
      style={{ display: 'flex', justifyContent: 'space-between' }}
    >
      {children}
    </Box>
  )
}

const InfoDropdown = () => {
  const theme = useTheme()
  const [isOpen, toggleOpen] = useReducer((s) => !s, false)
  const ref = useRef<HTMLDivElement>(null)
  useOnClickOutside(ref, isOpen ? toggleOpen : undefined)
  const competitionInfo = useCompetitionInfo()
  const locale = useActiveLocale()

  const getFormattedDate = (timestamp: number) => {
    return new Date(timestamp * 1000).toLocaleDateString(locale, {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: 'numeric',
    })
  }
  return (
    <Box position="relative" ref={ref} marginRight="4">
      <ButtonOutlined
        style={{
          padding: '9px 20px',
          width: 'auto',
          fontSize: '14px',
          fontWeight: '500',
          borderRadius: '12px',
        }}
        onClick={toggleOpen}
      >
        <EllipsisIcon viewBox="0 0 20 20" width={15} height={15} color={theme.textPrimary} />
      </ButtonOutlined>

      {isOpen && (
        <NavDropdown top={{ sm: 'unset', lg: '56' }} bottom={{ sm: '56', lg: 'unset' }} right="0">
          <Column gap="16">
            {!competitionInfo.isLoading && (
              <Box
                display="flex"
                flexDirection={{ sm: 'row', md: 'column' }}
                flexWrap="wrap"
                alignItems={{ sm: 'center', md: 'flex-start' }}
                paddingX="8"
              >
                <SecondaryLinkedText>
                  <Column>
                    <div>Competition started:</div>
                    <div style={{ color: theme.textPrimary }}>
                      {getFormattedDate(competitionInfo.data.tradingCompetition?.competitionStart)}
                    </div>
                  </Column>
                </SecondaryLinkedText>
                <SecondaryLinkedText>
                  <Column>
                    <div>Competition ends:</div>
                    <div style={{ color: theme.textPrimary }}>
                      {getFormattedDate(competitionInfo.data.tradingCompetition?.competitionEnd)}
                    </div>
                  </Column>
                </SecondaryLinkedText>
              </Box>
            )}
          </Column>
        </NavDropdown>
      )}
    </Box>
  )
}

export default InfoDropdown
